// extracted by css-extract-rspack-plugin
export default {"empty":"mzVF197LFfMSfdZI","body":"X_7wGAZE1KcXD13p","title":"n_cOgcutt60h5cdd","meta":"hILCZTO60ZQ2lDNk","time":"h3K2fPYzVYjY3b5s","month":"vYWjqCRfi8407VkH"};